module.exports = __webpack_public_path__ + "static/media/elchome2.df91aff5.PNG";